/**
 * 成果价值评估相关 API
 */
import request from '@/utils/request'
import baseUrl from '@/utils/baseUrl'

const valueAssessmentApi = {}

/**
 * 价值评估归档列表（分页）
 * @param {Object} params
 * @param {Number} params.pageNum 页码，默认 1
 * @param {Number} params.pageSize 每页条数，默认 10
 */
valueAssessmentApi.getArchiveList = function(params = {}) {
  const query = {
    pageNum: params.pageNum || 1,
    pageSize: params.pageSize || 10
  }
  if (params.achievementName) query.achievementName = params.achievementName
  if (params.firstCategory) query.firstCategory = params.firstCategory
  if (params.secondCategory) query.secondCategory = params.secondCategory
  if (params.field) query.field = params.field
  if (params.achievementType) query.achievementType = params.achievementType
  if (params.valuationPeriod) query.valuationPeriod = params.valuationPeriod
  if (params.valuationScore) query.valuationScore = params.valuationScore
  if (params.technologyReadinessLevel) {
    query.technologyReadinessLevel = params.technologyReadinessLevel
  }

  return request({
    url: '/open/value-assess-archive/list',
    method: 'get',
    params: query,
    baseURL: baseUrl.valueAssess,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

/**
 * 获取价值评估报告详情
 * @param {String|Number} templateRecordId 模板记录 ID（列表项 templateRecordId）
 */
valueAssessmentApi.getReportInfo = function(templateRecordId) {
  const id = templateRecordId != null ? String(templateRecordId) : ''
  return request({
    url: `/open/value-assess-archive/${encodeURIComponent(id)}`,
    method: 'get',
    baseURL: baseUrl.valueAssess,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export default valueAssessmentApi
